import React, { useEffect, useState } from "react";
import { Headers, SlimHeaderFullResponsive } from "design-react-kit";
// import smartcitylogo from "../../Img/smartcitylogo.PNG";
import mainLogo from "../../Img/semplicita-catasto.png";
import configuration from "../Utility/config.json";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import logo from "../../Img/logo.svg";
import Repo from "../Utility/Repo";
import { Link, useLocation } from "react-router-dom";
import jwt_decode from "jwt-decode";
import Cookies from "universal-cookie";

function Header(props) {
  const cookies = new Cookies();
  const [apiToken] = useState(cookies.get("token_key"));
  const [isOperator, setIsOperator] = useState(false);
  const [isStatsViewer, setIsStatsViewer] = useState(false);
  const [isSuperDelegate, setIsSuperDelegate] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [ordiniNonPagati, setOrdiniNonPagati] = useState();
  let location = useLocation();
  const auth_url = window.__RUNTIME_CONFIG__.REACT_APP_AUTH_URL;

  const queryParameters =
    "?returnUrl=" +
    window.location.protocol +
    "//" +
    window.location.hostname +
    ":3008" +
    props.subfolder;

  // const queryParameters =
  //   "?returnUrl=" +
  //   window.location.protocol +
  //   "//" +
  //   window.location.hostname +
  //   props.subfolder;

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    if (apiToken && cookies) {
      var decoded = jwt_decode(apiToken);

      if (decoded.role && typeof decoded.role === "object") {
        if (decoded.role.includes("STATSVIEWER")) {
          setIsStatsViewer(true);
        } else if (decoded.role.includes("OPERATOR")) {
          setIsOperator(true);
        } else if (decoded.role.includes("SUPER_DELEGATE")) {
          setIsSuperDelegate(true);
        } else {
          Repo.getOrdini(apiToken, false)
            .then((response) => {
              setOrdiniNonPagati(response.data);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (decoded.role && typeof decoded.role === "string") {
        if (decoded.role == "STATSVIEWER") {
          setIsStatsViewer(true);
        } else if (decoded.role == "OPERATOR") {
          setIsOperator(true);
        } else if (decoded.role == "SUPER_DELEGATE") {
          setIsSuperDelegate(true);
        } else {
          Repo.getOrdini(apiToken, false)
            .then((response) => {
              setOrdiniNonPagati(response.data);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    }
  }, []);

  const deleteToken = () => {
    cookies.remove("token_key");
    window.location.href = props.subfolder + "/home";
  };

  const matchMenu = (linkName) => {
    if (
      location.pathname
        .toLowerCase()
        .replace("_", " ")
        .includes(linkName.toLowerCase())
    ) {
      return true;
    } else if (
      (location.pathname == "/Home" || location.pathname == "/") &&
      linkName == "Home"
    ) {
      return true;
    }
  };

  const login = () => {
    return (
      <div className="it-user-wrapper nav-item dropdown">
        <Link
          to="/#"
          className="btn btn-primary btn-icon btn-full"
          data-toggle="dropdown"
          // aria-haspopup="true"
          aria-expanded="false"
        >
          <span className="rounded-icon">
            <svg className="icon icon-primary ml-0">
              <use href={`${iconSprite}#it-user`} />
            </svg>
          </span>
          <span className="d-lg-block">Area Personale</span>
        </Link>
        <div
          className="dropdown-menu"
          x-placement="bottom-start"
          style={{
            position: "absolute",
            willChange: "transform",
            top: "0px",
            left: "0px",
            transform: "translate3d(0px, 48px, 0px)",
          }}
        >
          <div className="link-list-wrapper">
            <ul className="link-list ">
              <li>
                <a
                  className="list-item"
                  href={props.subfolder + "/login"}
                  onClick={() => window.location.reload()}
                >
                  <span className="ml-1">
                    <b>Accedi</b>
                  </span>
                </a>
              </li>
              <li>
                <a
                  className="list-item"
                  href={props.subfolder + "/login?reg=true"}
                >
                  <span className="ml-1">
                    <b>Registrati</b>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  };

  const cart = () => {
    return (
      <Link to="/ordini_sospeso" pagato={"false"} className="mx-0">
        <div className="pl-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            fill="currentColor"
            className="bi bi-cart"
            viewBox="0 0 16 16"
          >
            <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
          </svg>
          <span className="badge badge-light ml-1">
            {ordiniNonPagati && ordiniNonPagati.length}
          </span>
        </div>
      </Link>
    );
  };

  const logout = () => {
    return (
      <>
        <div className="it-user-wrapper nav-item dropdown">
          <Link
            to="/#"
            className="btn btn-primary btn-icon btn-full"
            data-toggle="dropdown"
            // aria-haspopup="true"
            aria-expanded="false"
          >
            <span className="rounded-icon">
              <svg className="icon icon-primary ml-0">
                <use href={`${iconSprite}#it-user`} />
              </svg>
            </span>
            <span className="d-none d-lg-block">
              {props.name.toUpperCase()}
            </span>
          </Link>
          <div
            className="dropdown-menu"
            x-placement="bottom-start"
            style={{
              position: "absolute",
              willChange: "transform",
              top: "0px",
              left: "0px",
              transform: "translate3d(0px, 48px, 0px)",
            }}
          >
            <div className="link-list-wrapper">
              <ul className="link-list ">
                <li>
                  <Link className="list-item" to="/profilo">
                    <svg className="icon icon-primary">
                      <use xlinkHref={`${iconSprite}#it-user`}></use>
                    </svg>

                    <span className="ml-1">
                      <b>Profilo</b>
                    </span>
                  </Link>
                </li>
                <li>
                  <a
                    className="list-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => deleteToken()}
                  >
                    <svg className="icon icon-primary">
                      <use xlinkHref={`${iconSprite}#it-external-link`}></use>
                    </svg>

                    <span className="ml-1">
                      <b>Esci</b>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <header className="it-header-wrapper it-header-sticky">
        <div className="it-header-slim-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="it-header-slim-wrapper-content">
                  <a
                    href="https://www.servizilocalispa.it"
                    style={{ fontSize: "12px" }}
                    target="_blank"
                  >
                    Servizi onlife by - Servizi Locali Spa
                  </a>

                  <div className="it-header-slim-right-zone ">
                    {apiToken && (
                      <>
                        {props.linksEsterni && props.linksEsterni.length < 2 ? (
                          <>
                            <div className="nav-item d-none d-lg-block">
                              {props.linksEsterni &&
                                props.linksEsterni.map((linkObb, index) => (
                                  <span className="linkMenu" key={index}>
                                    <Link to={linkObb.Url}>
                                      {linkObb.Title}
                                    </Link>
                                  </span>
                                ))}
                            </div>
                          </>
                        ) : (
                          <>
                            {/* <div className="nav-item dropdown">
                            <Link
                              className="nav-link dropdown-toggle"
                              to="/#"
                              data-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <span>Smart City Pa</span>
                              <svg className="icon d-none d-lg-block align-middle">
                                <use href={`${iconSprite}#it-expand`} />
                              </svg>
                            </Link>
                            <div className="dropdown-menu">
                              <div className="row">
                                <div className="col-12">
                                  <div className="link-list-wrapper">
                                    <ul className="link-list">
                                      <li>
                                        <Link
                                          className="list-item"
                                          to="https://smartcondominio.servizilocalispa.it:3002/"
                                        >
                                          <span>Smart Condominio</span>
                                        </Link>{" "}
                                      </li>
                                      {props.linksEsterni &&
                                        props.linksEsterni.map(
                                          (linkObb, index) => (
                                            <li key={index}>
                                              <Link
                                                className="list-item"
                                                to={linkObb.Url}
                                              >
                                                <span>{linkObb.Title}</span>
                                              </Link>{" "}
                                            </li>
                                          )
                                        )}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}
                          </>
                        )}
                      </>
                    )}
                    <div className="it-access-top-wrapper mr-2">
                      {apiToken ? logout() : login()}
                    </div>
                    <div className="it-access-top-wrapper mr-2">
                      {apiToken &&
                      !isOperator &&
                      !isStatsViewer &&
                      !isSuperDelegate
                        ? cart()
                        : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="it-nav-wrapper">
          <div className="it-header-center-wrapper">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="it-header-center-content-wrapper ">
                    <div className="it-brand-wrapper px-0 mx-0">
                      <div className="row">
                        {width < 992 && (
                          <div className="col-2 pt-3">
                            <a className="">
                              <button
                                className="custom-navbar-toggler"
                                type="button"
                                aria-controls="nav02"
                                aria-expanded="false"
                                aria-label="Toggle navigation"
                                data-target="#nav02"
                              >
                                <svg className="icon">
                                  <use
                                    href={`${iconSprite}#it-burger`}
                                    width="70%"
                                  />
                                </svg>
                              </button>
                            </a>
                          </div>
                        )}
                        <div className="col-10 mt-1">
                          <a className="">
                            <img height="100" src={logo} alt="logo" />
                            <div className="it-brand-text">
                              <h2 className="no_toc ">
                                {" "}
                                <img
                                  className="img-fluid customLogo"
                                  src={mainLogo}
                                  alt="mainlogo"
                                />
                              </h2>
                            </div>
                          </a>
                        </div>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Headers shadow={false} sticky>
            <div className="it-header-navbar-wrapper ">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <nav className="navbar navbar-expand-lg has-megamenu">
                      <div
                        className="navbar-collapsable"
                        id="nav02"
                        style={{ display: "none", width: "80%" }}
                      >
                        <div
                          className="overlay"
                          style={{ display: "none" }}
                        ></div>
                        <div className="close-div sr-only">
                          <button className="btn close-menu" type="button">
                            <span className="it-close"></span>close
                          </button>
                        </div>
                        <div className="menu-wrapper">
                          <ul className="navbar-nav">
                            {props.links &&
                              props.links.map((linkObb, index) => (
                                <li className="nav-item" key={index}>
                                  <Link
                                    {...(matchMenu(linkObb.testo)
                                      ? {
                                          className:
                                            "nav-link active customMenu customLink",
                                        }
                                      : { className: "nav-link customLink" })}
                                    to={linkObb.url}
                                  >
                                    <span style={{ width: "max-content" }}>
                                      {linkObb.testo}{" "}
                                    </span>
                                    <span className="sr-only">current</span>
                                  </Link>
                                </li>
                              ))}
                          </ul>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </Headers>
        </div>
      </header>
    </>
  );
}

export default Header;
export const MemoizedHeader = React.memo(Header);
